
function Header() {
  return (
    <div className="bg-slate-400 h-20 flex items-center justify-center">
      <h1 className="text-3xl">Incel Lingo Translator</h1>
    </div>
  )
}

export default Header